import { agentTraining } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import { AgentTrainingChatMock } from './AgentTrainingChatMock';
import './AgentTraining.css';

export function AgentTraining() {
  return (
    <Section
      id="entrenamiento"
      label={agentTraining.label}
      title={agentTraining.title}
      lead={agentTraining.lead}
      className="training-section"
    >
      <div className="training-layout">
        <ScrollReveal>
          <ol className="training-steps">
            {agentTraining.steps.map((step, i) => (
              <li key={step.id} className="training-step glass-card">
                <span className="training-step__emoji" aria-hidden>
                  {step.emoji}
                </span>
                <div>
                  <h3 className="training-step__title">{step.title}</h3>
                  <p className="training-step__body">{step.body}</p>
                </div>
                <span className="training-step__index">{i + 1}</span>
              </li>
            ))}
          </ol>
        </ScrollReveal>

        <ScrollReveal delay={120}>
          <AgentTrainingChatMock />
        </ScrollReveal>
      </div>
    </Section>
  );
}
